export const hybridspaceWorkPlanLink = "uF0UFe";
export const hybridspaceDevPanelLink = "XZAtWd";
export const hybridspaceExplorePageLink = "GBOzNe";
export default {hybridspaceWorkPlanLink,hybridspaceDevPanelLink,hybridspaceExplorePageLink};